import { crmApi } from '@/api'
import Select from '@pages/Admin/CRM/components/base/Select/Select'
import { FC, useEffect, useState } from 'react'
import { useAsyncFn } from 'react-use'

interface SelectLeadProps {
  value: number | null
  onChange: (value: number | null) => void
  className?: string
}

const SelectLead: FC<SelectLeadProps> = ({ value, onChange, className }) => {
  const [searchText, setSearchText] = useState('')
  const [leadsState, doFetchLeads] = useAsyncFn(async () => {
    let filter: any = { 'per-page': 200, 'filter[unused]': true }
    if (searchText.trim())
      filter = { 'filter[search]': searchText.trim(), ...filter }
    return await crmApi.searchLeadsForSelect({ ...filter })
  }, [searchText])

  const leadsData = leadsState.value?.data?.data || []

  useEffect(() => {
    doFetchLeads()
  }, [searchText, doFetchLeads])

  useEffect(() => {
    if (value === null) setSearchText('')
  }, [value])

  return (
    <Select
      showSearch
      loading={leadsState.loading}
      options={leadsData}
      onSearch={(text) => setSearchText(text)}
      value={value}
      onChange={onChange}
      placeholder="Введите ФИО, почту или номер телефона лида"
      className={className}
    />
  )
}

export default SelectLead
